import React from "react";
import FractionStore from "../../stores/fraction-store";
import Dispatcher from "../../dispatcher";

const MainMenuMixin = {
  _toggleMainMenu: function(e, updatePowerByClass) {
    if (FractionStore.get()["main-menu-open"]) {
      this._menuClose(e);
    } else {
      this._menuOpen(e, updatePowerByClass);
    }
  },

  _menuOpen: function(updatePowerByClass, e) {
    Dispatcher.emit(Dispatcher.MAIN_MENU_OPEN);
    $(".main-menu")
      .removeClass("menu-hidden")
      .addClass("menu-open")
      .css("top", "0");
    $("#menu-button, #mobile-menu-button").attr("aria-pressed", "true");
    $("#mainMenuHeader").focus();
    $(
      ".main-menu, header, #book-list, .book-results-bottom, .account-container, #vertical-toolbar, #mobile-toolbar, #mobile-scrubber-container, .small-account-graphic object, #library-filter"
    ).addClass("open-menu-content");
    $(".menu-close-container").removeClass("menu-close-hidden");
    // Added below to account for vertical toolbar width/position
    if ($(window).width() <= 645) {
      $("#reader-content").css({ left: "270px", right: "-270px" });
    } else {
      $("#reader-content").css({ left: "314px", right: "-314px" });
    }
    if (updatePowerByClass && typeof updatePowerByClass === "function") {
      if ($(".main-menu")[0].scrollHeight > $(window).height()) {
        updatePowerByClass(1);
      } else if ($(".main-menu-inner").height() < $(".main-menu").height()) {
        updatePowerByClass(2);
      } else {
        updatePowerByClass(3);
      }
    }
  },

  _menuClose: function(e) {
    e.preventDefault();
    Dispatcher.emit(Dispatcher.MAIN_MENU_CLOSE);
    if ($(".main-menu").hasClass("menu-open")) {
      $(".menu-close-container").addClass("menu-close-hidden");
      $(
        ".main-menu, header, #library, .book-results-bottom, .account-container, #vertical-toolbar, #mobile-scrubber-container, #mobile-toolbar, #book-list, .small-account-graphic object, #library-filter"
      )
        .removeClass("open-menu-content")
        .addClass("closed-menu-animation");
      $(".main-menu")
        .addClass("menu-hidden")
        .removeClass("menu-open");
      // Not sure if we need the line below just yet //
      //$('#book-container, #scrubber-container, #mobile-scrubber-container, #library-filter, .account-container').css('min-width', '');
      $("#reader-content").css({ left: "", right: "" });
      $("#menu-button, #mobile-menu-button").attr("aria-pressed", "false");
      MainMenuMixin._menuRefocus(e);
    }
  },

  _menuRefocus: function(e) {
    if (
      $("#menu-button").length > 0 &&
      $(".main-menu").hasClass("menu-hidden")
    ) {
      $("#menu-button").focus();
    } else if (
      $("#mobile-menu-button").length > 0 &&
      $(".main-menu").hasClass("menu-hidden")
    ) {
      $("#mobile-menu-button").focus();
    } else if (
      $(".menu-icon").length > 0 &&
      $(".main-menu").hasClass("menu-hidden")
    ) {
      $(".menu-icon").focus();
    } else {
      $("#menu-button").focus();
    }
  }
};

export default MainMenuMixin;
